module.exports = __webpack_public_path__ + "img/content3.ce099feb.png";